import { useTranslate } from 'hooks/useTranslate';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { State } from 'redux/initialState';

import operationTypes from 'constants/operationTypes';

import OperationMenuDots from 'modules/_shared/components/MenuDots/OperationMenuDots';
import PageWithTabs from 'modules/_shared/components/Pages/PageWithTabs';
import Button from 'modules/_shared/components/Buttons';

import { useOperationDetailsPage } from '../context/OperationDetailsPageContext';
import documentsDropdownOptions from '../constants/documentsDropdownOptions';

import { getDocumentTitle } from '../utils/getDocumentTitle';

import OperationInfoSection from './OperationInfoSection';
import OperationDetailsDocumentsTab from './OperationDetailsDocumentsTab';
import OperationDetailsDataTab from './OperationDetailsDataTab';

const OperationDetailsPageBody = () => {
  const { t } = useTranslate();

  const printRef = useRef(null);
  const { data, actions } = useOperationDetailsPage();

  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );

  const tabs = [
    {
      key: 'details-tab',
      title: t('Details'),
      icon: 'ni-list-index-fill',
      content: <OperationDetailsDataTab />,
    },
    {
      key: 'documents-tab',
      title: t('Scriptures'),
      icon: 'ni-file-docs',
      content: <OperationDetailsDocumentsTab />,
    },
  ];

  return (
    <div className="nk-block">
      <div className="invoice">
        <div className="invoice-action d-flex align-items-center justify-content-between">
          {data.operation?.operationType ===
            operationTypes.DIVIDENDS_DISTRIBUTION && (
            <>
              <div className="mr-2">
                <Button
                  onClick={actions.handleNotifyPartners}
                  disabled={data.isOldOperation}
                >
                  <em className="icon ni ni-send mr-2" />
                  {t('NotifyPartners')}
                </Button>
              </div>

              <div className="mr-2">
                <OperationMenuDots
                  title={t('Download')}
                  menuOptions={documentsDropdownOptions}
                  params={{
                    hasSEPAOption:
                      actualSociety?.configuration?.hasSEPAOption &&
                      !data.isOldOperation,
                    hasTaxTemplate:
                      actualSociety?.templates?.tax2024 && !data.isOldOperation,
                    hasDividendTemplate: !data.isOldOperation,
                    handleGenerateBankDocument:
                      actions.handleGenerateBankDocument,
                    handleGenerateTaxDeclaration:
                      actions.handleGenerateTaxDeclaration,
                    handleOpenDividendModal: actions.handleOpenDividendModal,
                  }}
                  disabled={data.isOldOperation}
                  handleModal={null}
                />
              </div>
            </>
          )}

          <ReactToPrint
            trigger={() => (
              <a className="btn btn-icon btn-lg btn-white btn-dim btn-outline-primary">
                <em className="icon ni ni-printer-fill" />
              </a>
            )}
            content={() => printRef.current || null}
            documentTitle={getDocumentTitle(actualSociety, data.operation)}
          />
        </div>

        <div className="invoice-wrap" ref={printRef}>
          <OperationInfoSection />

          <PageWithTabs tabs={tabs} />
        </div>
      </div>
    </div>
  );
};

export default OperationDetailsPageBody;
